<template>
    <th
        v-if="isHeader"
        class="vuetable-th-component-status-date"
        @click="orderBy(rowField, $event)"
        v-html="title"
    />
    <td
        v-else
        class="vuetable-td-component-status-date"
    >
        <span
            span
            v-html="label(rowData, rowField)"
        />
    </td>
</template>

<script>
import VuetableFieldMixin from "vuetable-2/src/components/VuetableFieldMixin.vue"

export default {
    name: "VuetableFieldCustom",
    mixins: [VuetableFieldMixin],
    methods: {
        label(rowData, rowField) {
            return typeof rowField.custom.label === "function" ? rowField.custom.label(rowData, rowField) : rowField.link.to;
        },
        orderBy(rowData, $event) {
            this.vuetable.orderBy(rowData, $event)
        }
    }
}
</script>


<style lang="scss">
.vuetable-td-component-link a{
    color: var(--execlist-color-blue);

    &:hover {
        color: var(--execlist-color-blue);
    }
}
</style>
